import PropTypes from 'prop-types';
import clsx from 'clsx';
import List from '@mui/material/List';
import { ListSubheader } from '@mui/material';
import {useHistory} from 'react-router-dom';
import {useKeycloak} from '@react-keycloak/web';
import useStyle from '../../Utils/Style';
import MenuItem from '../MenuItem';

const MenuList = ({ items, subHeader, roles }) => {
  const classes = useStyle();
  const history = useHistory();
  const {keycloak} = useKeycloak();

  const activeRoute = (routeName) => {
    return history?.location?.pathname === routeName;
  };

  return (
    <List
      className="p-0"
      subheader={
        subHeader && (
          <ListSubheader className="text-gray-300 leading-4 px-0 mx-5 mt-1 mb-3" component="div">
            {subHeader}
          </ListSubheader>
        )
      }
    >
      {items
          .filter((k) => k?.isShow)
          .filter((k) => keycloak.authenticated || k?.isPublic)
          .map((item) => {
            if ((item.roles || []).length > 0) {
              const hasRole = (roles || [])
                  .map((r) => (item.roles || [])
                      .some((i) => i.toLowerCase().includes(r.toLowerCase()))).includes(true);
              if (!hasRole) return;
            }

            const listItemClasses = clsx('py-0 my-2 mx-0 px-0', {[classes.activeItem]: activeRoute(item.path)});
            return <MenuItem key={`menu-item-${item.id}`} listItemClasses={listItemClasses} item={item}/>;
          })}
    </List>
  );
};

MenuList.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  subHeader: PropTypes.oneOfType([
    PropTypes.node,
  ]).isRequired,
  roles: PropTypes.arrayOf(PropTypes.string),
};

MenuList.defaultProps = {
  roles: null,
};
export default MenuList;
